import React from "react";
import PipeCardEdit from "./PipeCardEdit";

export default function PipeSettings({
                                         pipe,
                                         onTitleChanged,
                                         onStatusChanged,
                                         onPeriodChanged,
                                         onApplyClick,
                                         onDeviceConfigurationClick
                                     }) {
    return <PipeCardEdit pipe={pipe}
                         onTitleChanged={onTitleChanged}
                         onStatusChanged={onStatusChanged}
                         onPeriodChanged={onPeriodChanged}
                         onApplyClick={onApplyClick}
                         onDeviceConfigurationClick={onDeviceConfigurationClick}
    />;
}